import { createReactBlockSpec, } from '@blocknote/react';
export const createCustomBlockSpec = (blockConfig, blockImplementation) => {
    const { config, implementation } = createReactBlockSpec(blockConfig, {
        render: ({ block, contentRef, editor }) => {
            return blockImplementation.render({
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                block: block,
                contentRef,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                editor: editor,
                readOnly: false,
            });
        },
    });
    return {
        config,
        implementation,
        render: blockImplementation.render,
    };
};
//# sourceMappingURL=createCustomBlockSpec.js.map